skrilla.service('modalService', function($q, $mdDialog){


    var isLoginModalOpen = false;
    function loginModal(){
        if(isLoginModalOpen === false){
            isLoginModalOpen = true;
            openModal("views/login/loginModal.html", true, "lg", false, false, function(){
                isLoginModalOpen = false;
            });
        }
    }

    function openModal(url, animation, size, backdrop, keyboard, callback, locals) {
        return $mdDialog.show({
            animation: animation,
            multiple: true,
            templateUrl: url,
            size: size,
            clickOutsideToClose: backdrop,
            keyboard: keyboard,
            locals: locals,
            onRemoving: function () {
                if (callback) {
                    callback();
                }
            }
        });
    }

    var dismissAll = function(){
        $mdDialog.hide();
    }

    //Getting a race condition from the API
    //Loading modal hadn't finished intialising by the time we got a response so $mdDialog.dismiss() was closing the most
    //recently initialised modal, which we werent intending to close.
    let loadingModalIsOpen = false;
    let loadingModalIsInitialised = false;
    let loadingModal;
    function openLoadingModal(){
        if(loadingModalIsOpen === false){
            loadingModalIsOpen = true;
            loadingModal = $mdDialog.show({
                animation: true,
                multiple: true,
                //size: 'lg',
                template: "<md-card style=\"height: 100px; width:90%;\">" +
                    "<div layout=\"row\" layout-sm=\"column\" layout-align=\"space-around\">" +
                "<md-progress-circular md-mode=\"indeterminate\" md-diameter=\"90\"></md-progress-circular>" +
                "</div>" +
                "</md-card>",
                clickOutsideToClose: false,
                keyboard: false,
                onRemoving: function(){
                    loadingModalIsOpen = false;
                    loadingModalIsInitialised = false;
                },
                onComplete: function(){
                    loadingModalIsInitialised = true;
                }
            });
        }
    }

    //Loading modal may be open in theory but not be initialised yet, try again in 100ms
    function closeLoadingModal(){
        if(loadingModalIsOpen === true){
            if(!loadingModalIsInitialised){
                setTimeout(closeLoadingModal, 100)
            }else {
                loadingModalIsOpen = false;
                loadingModalIsInitialised = false;
                $mdDialog.hide();
            }
        }
    }


    var confirm = function (text, successCallback, errorCallback) {
        swal({
                title: "Input Required",
                text: text,
                type: "warning",
                showCancelButton: true,
                confirmButtonText: "Yes!",
                cancelButtonText: "No, cancel!",
                closeOnConfirm: true,
                html:true
            },
            function (isConfirm) {
                if(isConfirm === true && successCallback){
                    //modalService.dismissAll();
                    setTimeout(function () {
                        successCallback();
                    }, 100)
                }
                else if(errorCallback){
                    setTimeout(function () {
                        errorCallback();
                    }, 100)
                }
            });
    }

    let error = function (text) {
        swal({
            title: "Error",
            text: text,
            type: "warning",
            showCancelButton: false,
            confirmButtonText: "Ok",
            closeOnConfirm: true,
            html: true,
        })
    }

    return {
        openModal: openModal,
        confirm: confirm,
        dismissAll: dismissAll,
        openLoadingModal:openLoadingModal,
        closeLoadingModal:closeLoadingModal,
        loginModal: loginModal,
        error: error,
    };
});

